export default "__VITE_ASSET__71babc6d__";